// Import the necessary dependencies for making API calls and managing state
import axios from "axios";
import { useEffect, useState } from "react";

// Store the API key and API URL in constants
const API_KEY = process.env.REACT_APP_GIPHY_API_KEY;
const url = `https://api.giphy.com/v1/gifs/random?api_key=${API_KEY}`;

// Create a custom hook called useGif that takes in a tag as an argument
const useGif = (tag) => {
  const [gif, setGif] = useState("");
  const [loading, setloading] = useState(false);

  // Define a function to fetch a random GIF using the Giphy API
  const fetchRandomGif = async (tag) => {
    // Set the loading state to true
    setloading(true);

    // Make a GET request to the Giphy API using the axios library
    const response = await axios.get(tag ? `${url}&tag=${tag}` : url);
    // Extract the data from the response
    const data = response.data;
    // Get the URL of the downsized large version of the GIF
    const image = data.data.images.downsized_large.url;
    // Update the state variable with the GIF URL
    setGif(image);
    // Set the loading state to false
    setloading(false);
  };

  // Use the useEffect hook to fetch a random GIF when the component mounts
  useEffect(() => {
    fetchRandomGif(tag);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Return an object with the fetched GIF and the fetchRandomGif function for refetching
  return { gif, loading, fetchRandomGif };
};

// Export the custom hook for use in other components
export default useGif;
